var React = require('react');

function ArrowShort (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M14.6548 10.8334H2.5V9.16673H14.6548L9.41074 3.92265L10.5893 2.74414L17.8452 10.0001L10.5893 17.256L9.41074 16.0775L14.6548 10.8334Z"}));
}

ArrowShort.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20"};

module.exports = ArrowShort;

ArrowShort.default = ArrowShort;
